import { LocationListResultFormatted } from "@/app/api/directory/location/format-location-list-data";
import { Location } from "./types";

const count = 34;
const pageCount = 20;

const fakeData: LocationListResultFormatted = {
  key: "0",
  name: "aaa",
  sectorOfActivity: "aaa",
  buildingName: "aaa",
  address: "aaa",
  city: "aaa",
  region: "aaa",
  country: "aaa",
  urlSlug: "aaa",
  numberOfCollaborators: "aaa",
  numberOfSaleTransactions3Years: "aaa",
  numberOfLeaseTransactions3Years: "aaa",
  numberOfArticles: "aaa",
  __itemId: "aaa",
  __listId: "aaa",
};

//spreading array here is required
const fakeDataSet: LocationListResultFormatted[] = [
  ...new Array(pageCount),
].map((_, i) => ({
  ...fakeData,
  key: i.toString(),
  __itemId: i.toString(),
  __listId: i.toString(),
}));

const fakeResultSet: Location[] = [...new Array(pageCount)].map((_, i) => ({
  __itemId: i.toString(),
}));

const getSearchWithListNotAuth = async () =>
  Promise.resolve({ data: fakeDataSet, result: fakeResultSet, pageNumber: 1 });

const getCountsNotAuth = async () => Promise.resolve(count);

export { getSearchWithListNotAuth, getCountsNotAuth };
